import React from "react";

/**
 * Shared chrome for auth pages: navy gradient background, glass card,
 * BiorGov wordmark at the top. Used by Login, ForgotPassword, ResetPassword,
 * AcceptInvite. Pure CSS — no JS dependencies.
 */
const AuthShell = ({ title, subtitle, children, footer }) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1.5rem",
        background:
          "radial-gradient(60% 80% at 80% -10%, rgba(123,124,255,0.22), transparent 60%)," +
          "radial-gradient(40% 60% at -10% 110%, rgba(0,205,82,0.10), transparent 60%)," +
          "linear-gradient(180deg, rgba(21,14,83,0.98), rgba(14,13,41,0.98))",
        color: "var(--bl-text-strong)",
        fontFamily: "var(--bl-font-body)",
      }}
    >
      <div style={{ maxWidth: 440, width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <h1
            style={{
              margin: 0,
              fontFamily: "var(--bl-font-display)",
              fontSize: "clamp(1.6rem, 5vw, 2rem)",
              fontWeight: 700,
              letterSpacing: "-0.01em",
              background: "linear-gradient(115deg, #ffffff 0%, #7B7CFF 70%, #3738C4 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
              color: "transparent",
            }}
          >
            BiorGov
          </h1>
          <p style={{ marginTop: 8, color: "var(--bl-text-soft)", fontSize: 14 }}>Admin Dashboard</p>
        </div>

        <div className="bl-glass-strong" style={{ padding: "2rem 1.75rem" }}>
          {(title || subtitle) && (
            <div style={{ marginBottom: "1.25rem" }}>
              {title && (
                <h2
                  style={{
                    margin: 0,
                    fontFamily: "var(--bl-font-display)",
                    fontSize: "1.35rem",
                    fontWeight: 700,
                    color: "#fff",
                    letterSpacing: "-0.01em",
                  }}
                >
                  {title}
                </h2>
              )}
              {subtitle && (
                <p style={{ marginTop: 6, marginBottom: 0, color: "var(--bl-text-soft)", fontSize: 14 }}>
                  {subtitle}
                </p>
              )}
            </div>
          )}
          {children}
        </div>

        {footer && (
          <p style={{ textAlign: "center", marginTop: "1.5rem", color: "var(--bl-text-soft)", fontSize: 14 }}>
            {footer}
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthShell;
